module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAASCAIAAAD9mVSFAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQZJREFUeNrs2jEKgzAYhuFYurm76+TiAdzdPIW3yODoEO/k7gEyq7u7ewOBIlLaYCUW+z5DbQUVfr6GTzRI01QIoZTKskwAV6S1llKaLzdmgf9B3EHcAeIOEHeAuAPEHTjL3W7GcWQWuKpnvAP7mAmgzADXKjObdwe01i6HhWFoPpdlYYLwL4qieZ5dUpokyXpPMAzD+ndZlh/PEsdx27bmXFJKx78HcJS6rvM8f74G84ZZypVS35YZczG7uhdFwfThmYmfjbJZ4310977vbY3puo7pwzMTP9u6XfrMtrvvuN40TVVV0d1xiqZpHLv7MXEn6DjXvqy/KDM7+hDwm+wd5tpDgAEAlENKlxtMfOAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/RAPS450.png
// module id = qwZI
// module chunks = 0